export default "__VITE_ASSET__55e56d17__"